interface Props {
    id: string
}

const ArrowRightIcon = ({ id }: Props) => {
    return (
        <svg
            width="14"
            height="23"
            viewBox="0 0 14 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.14013 1.18381e-06C2.72611 1.13258e-06 3.19745 0.200001 3.60509 0.600001L13.1975 9.775C13.7452 10.3125 13.9873 10.8375 14 11.5C14 12.15 13.7452 12.7 13.1975 13.225L3.61783 22.4125C3.19745 22.8 2.71338 23 2.14013 23C0.968153 23 -8.08661e-08 22.075 -1.81402e-07 20.925C-2.3167e-07 20.35 0.254777 19.825 0.687898 19.3875L9.00637 11.4875L0.687896 3.6125C0.242037 3.175 -1.77905e-06 2.65 -1.82932e-06 2.075C-1.92876e-06 0.937501 0.968151 1.28627e-06 2.14013 1.18381e-06Z"
                fill={`url(#${id}-gradient)`}
            />
            <defs>
                <linearGradient
                    id={`${id}-gradient`}
                    x1="7"
                    y1="23"
                    x2="7"
                    y2="1.29539e-06"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E53D82" stopOpacity="0.47" />
                    <stop offset="1" stopColor="#6B19BC" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default ArrowRightIcon;
